<template>
    <div class="xeIndoorEnvInfo heightMAX rounded" :class="{ 'is-overview-compact': isOverviewCompact }" style="overflow: hidden">
        <div class="heightMAX">
            <!-- <div class="jvectormap-container " style="background-color: transparent; position:relative"> -->
            <drop
                @dragover="handleBodyDragOver(...arguments)"
                @drop="handleBodyDrop(...arguments)"
                class="heightMAX kbet-custom-reset"
            >
                <div class="rounded kbet-widget-energy monitoring heightMAX" style="display: block">
                    <p class="title">{{ $t(widget.title) }}</p>
                    <div class="monitoring_wrap">
                        <ul class="info">
                            <li
                                v-for="(data, i) in indoorEnvInfoList"
                                :key="`info${i}`"
                                :class="`${data.propCode?.includes('TEMP') ? '' : 'env-card'} info${i + 1 < 10 ? '0' + (i + 1) : i + 1}`"
                                :style="getItemStyle(data)"
                            >
                                <div :class="data.propCode?.includes('TEMP') ? 'temp-card-div' : 'env-card-dl'">
                                    <dt
                                        :class="
                                            data.propCode?.includes('TEMP')
                                                ? 'temp-title-font-style'
                                                : 'indoor-env-info-title'
                                        "
                                        :style="{ wordBreak: 'keep-all' }"
                                    >
                                        {{ i === 0 ? (sysNodeName ?? "-") : (data.propName ?? "-") }}
                                    </dt>
                                    <div :class="data.propCode?.includes('TEMP') ? '' : 'env-card-div-content'">
                                        <div
                                            class="icon-container"
                                            :class="{
                                                'humi-container': getItemType(data) === 'HUMI',
                                                'co2-container': getItemType(data) === 'CO2',
                                                'pm2-container': getItemType(data) === 'PM2.5',
                                            }"
                                        >
                                            <humi-icon
                                                :size="isOverviewCompact ? 22 : 30"
                                                v-if="getItemType(data) === 'HUMI'"
                                                class="item-icon"
                                            />
                                            <co2-icon
                                                :size="isOverviewCompact ? 56 : 90"
                                                v-if="getItemType(data) === 'CO2'"
                                                class="item-icon"
                                            />
                                            <pm25-icon
                                                :size="isOverviewCompact ? 56 : 90"
                                                v-if="getItemType(data) === 'PM2.5'"
                                                class="item-icon"
                                            />
                                            <water-drop-animation v-if="getItemType(data) === 'HUMI'" />
                                            <cloud-animation v-if="getItemType(data) === 'CO2'" />
                                            <dust-animation v-if="getItemType(data) === 'PM2.5'" />
                                        </div>
                                        <div class="font-roboto-slab">
                                            <span
                                                :class="
                                                    data.propCode?.includes('TEMP')
                                                        ? 'temp-value-font-style font-roboto-slab'
                                                        : 'indoor-env-info-value font-roboto-slab'
                                                "
                                                >{{ `${data.sumVal ?? "-"}` }}</span
                                            ><br v-if="!data.propCode?.includes('TEMP')" class="value-unit-break" />
                                            <span
                                                :class="
                                                    data.propCode?.includes('TEMP')
                                                        ? 'temp-unit-font-style font-roboto-slab'
                                                        : 'indoor-env-info-unit font-roboto-slab'
                                                "
                                            >
                                                {{ `${data.unit ?? "-"}` }}
                                            </span>
                                        </div>
                                    </div>
                                    <!-- TEMP일 때 DI와 PMV 지수 표시 -->
                                    <div v-if="data.propCode?.includes('TEMP')" class="temp-indices">
                                        <div class="index-item">
                                            <span class="index-label">DI :</span>
                                            <span class="index-value">{{ getIndexValue("DI") }}</span>
                                        </div>
                                        <div class="index-item">
                                            <span class="index-label">PMV :</span>
                                            <span class="index-value">{{ getIndexValue("PMV") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </drop>
        </div>

        <b-modal
            ref="modalSetting"
            size="sm"
            :title="`${$t('설정')} - ${$t('실내환경정보')}`"
            bodyClass="p-t-0 p-b-0"
            hide-footer
        >
            <indoor-env-info-setting :initSetting="setting" @on-modal-cancel="onModalCancel" @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import indoorEnvInfoSetting from "./setting/xeIndoorEnvInfoSetting.vue";

import humiIcon from "../../../../public/assets/xems/common/widget/indoorEnvInfo/HumiSvgCode";
import co2Icon from "../../../../public/assets/xems/common/widget/indoorEnvInfo/Co2SvgCode";
import pm25Icon from "../../../../public/assets/xems/common/widget/indoorEnvInfo/Pm2.5SvgCode";
import WaterDropAnimation from "./components/WaterDropAnimation.vue";
import CloudAnimation from "./components/CloudAnimation.vue";
import DustAnimation from "./components/DustAnimation.vue";

export default {
    name: "xeIndoorEnvInfo",
    props: ["showGrid", "widget", "cellSize", "on-remove-widget"],
    extends: xeBaseWidget,
    components: {
        indoorEnvInfoSetting,
        // HumiIcon,
        humiIcon,
        co2Icon,
        pm25Icon,
        WaterDropAnimation,
        CloudAnimation,
        DustAnimation,
    },
    created() {
        this.widget.queryType = "NOW";
    },
    mounted() {},
    data() {
        return {
            indoorEnvInfoList: [],
            sysNodeName: "",

            equipInfoList: [],
            equipPropList: [],
            equipInfo: {
                HUMI: 0,
                PM10: 0,
                PM20: 0,
                CO2: 0,
                TEMP: 0,
                equipIdx: 0,
                equipName: "",
            },

            outherValues: {
                DI: null,
                PMV: null,
            },
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
        };
    },
    computed: {
        setting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
    },
    methods: {
        applyData(data) {
            this.setDatas(data);
        },

        setDatas(data) {
            this.sysNodeName = data.sysNodeName;
            if (data.summary) {
                this.indoorEnvInfoList = data.summary;
                this.outherValues.DI = this.indoorEnvInfoList.find((item) => item.propCode === "DI")?.sumVal;
                this.outherValues.PMV = this.indoorEnvInfoList.find((item) => item.propCode === "PMV")?.sumVal;
                const findPMV = this.indoorEnvInfoList.find((item) => item.propCode === "PMV");
                const findDI = this.indoorEnvInfoList.find((item) => item.propCode === "DI");
                if (findPMV) this.indoorEnvInfoList = this.indoorEnvInfoList.filter((item) => item.propCode !== "PMV");
                if (findDI) this.indoorEnvInfoList = this.indoorEnvInfoList.filter((item) => item.propCode !== "DI");
                this.indoorEnvInfoList = this.sortIndoorEnvInfoList(this.indoorEnvInfoList);
                this.indoorEnvInfoList.forEach((item) => {
                    item.sumVal = Number.isInteger(item.sumVal) ? item.sumVal : item.sumVal?.toFixed(1);
                    item.unit = this.$store.state.units?.find((unit) => unit.value === item.unit)
                        ? this.$store.state.units.find((unit) => unit.value === item.unit).text
                        : item.unit;
                });
            } else this.indoorEnvInfoList = [];
        },
        // temp, humi, co2, pm25 순서로 리스트 정렬
        sortIndoorEnvInfoList(list) {
            const temp = list.find((item) => item.propCode.includes("TEMP")) || {
                propName: "TEMP",
                sumVal: null,
                unit: null,
            };
            const humi = list.find((item) => item.propCode.includes("HUMI")) || {
                propName: "HUMI",
                sumVal: null,
                unit: null,
            };
            const co2 = list.find((item) => item.propCode.includes("CO2")) || {
                propName: "CO2",
                sumVal: null,
                unit: null,
            };
            const pm25 = list.find((item) => item.propCode.includes("PM2.5")) || {
                propName: "PM2.5",
                sumVal: null,
                unit: null,
            };

            return [temp, humi, co2, pm25];
        },
        getFontColor(data) {
            if (data.propCode?.includes("HUMI")) {
                return "#0D47A1";
            } else if (data.propCode?.includes("CO2")) {
                return "#757575";
            } else if (data.propCode?.includes("PM2.5")) {
                return "#4CAF50";
            } else if (data.propCode?.includes("TEMP")) {
                return "#FF5722";
            } else return "black";
        },
        getItemStyle(data) {
            const baseColor = this.getItemBaseColor(data);
            const borderColor = this.getItemBorderColor(data);
            if (!baseColor) return {};

            const compact = this.isOverviewCompact;
            return {
                background: `linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)`,
                borderRadius: compact ? "8px" : "12px",
                padding: compact ? "4px 6px" : "10px",
                margin: compact ? "2px 0" : "6px 0",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                borderTop: `${compact ? 3 : 4}px solid ${borderColor}`,
                color: this.getFontColor(data),
            };
        },
        getItemBaseColor(data) {
            if (data.propCode?.includes("HUMI")) {
                return "#B2EBF2";
            } else if (data.propCode?.includes("CO2")) {
                return "#BDBDBD";
            } else if (data.propCode?.includes("PM2.5")) {
                return "#7EDC7E";
            }
            return null; // 기본 스타일 적용
        },
        getItemBorderColor(data) {
            if (data.propCode?.includes("HUMI")) {
                return "#0D47A1"; // 습도 - 파란색
            } else if (data.propCode?.includes("CO2")) {
                return "#757575"; // CO2 - 회색
            } else if (data.propCode?.includes("PM2.5")) {
                return "#4CAF50"; // PM2.5 - 초록색
            } else if (data.propCode?.includes("TEMP")) {
                return "#FF5722"; // 온도 - 주황색
            }
            return "#E0E0E0"; // 기본 border 색상
        },
        getItemType(data) {
            if (data.propCode?.includes("HUMI")) {
                return "HUMI";
            } else if (data.propCode?.includes("CO2")) {
                return "CO2";
            } else if (data.propCode?.includes("PM2.5")) {
                return "PM2.5";
            }
            return "";
        },
        getIndexValue(indexType) {
            if (indexType === "DI") {
                return this.outherValues.DI;
            } else if (indexType === "PMV") {
                return this.outherValues.PMV;
            }
            return "-";
        },
    },
};
</script>

<style scoped>
.env-card {
    position: relative;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    padding: 10px;
    margin: 6px 0;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.env-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.no-shadow {
    position: relative;
    box-shadow: none !important;
}

.no-shadow::before {
    display: none;
}

.icon-container {
    display: block;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transform: translateY(-12%);
    z-index: 1;
}

.humi-container {
    /* overflow: hidden; */
}

.co2-container {
    /* overflow: hidden; */
}

.pm2-container {
    /* overflow: hidden; */
}

.item-icon {
    object-fit: contain;
    z-index: 1;
}
.indoor-env-info-value {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0px;
    line-height: 1;
}

.indoor-env-info-unit {
    font-size: 11px;
    font-weight: 800;
    margin-top: -4px;
    line-height: 0.6;
}

.indoor-env-info-title {
    font-size: 13px !important;
    font-weight: 800;
    color: #6c757d;
    position: relative;
    z-index: 2;
}
.temp-unit-font-style {
    font-size: 15px !important;
    font-weight: 400;
}
.temp-title-font-style {
    font-size: 13px !important;
    font-weight: 600;
    position: relative;
    z-index: 2;
}
.temp-value-font-style {
    font-size: 26px !important;
    font-weight: 600;
}
.env-card-dl {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.env-card-div-content {
    height: 65%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.temp-card-div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.temp-indices {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 4px;
}

.index-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
}

.index-label {
    font-size: 9px;
    font-weight: 600;
    color: #6c757d;
    min-width: 20px;
}

.index-value {
    font-size: 11px;
    font-weight: 700;
    color: #495057;
}
.value-unit-break {
    line-height: 0.1;
    margin: 0;
    padding: 0;
    height: 0;
}

.xeIndoorEnvInfo.is-overview-compact .env-card {
    border-radius: 8px;
    padding: 4px 6px;
    margin: 2px 0;
}

.xeIndoorEnvInfo.is-overview-compact .indoor-env-info-value {
    font-size: 13px;
    display: inline;
}

.xeIndoorEnvInfo.is-overview-compact .indoor-env-info-unit {
    font-size: 9px;
    display: inline;
    margin-left: 2px;
    margin-top: 0;
    line-height: 1;
}

.xeIndoorEnvInfo.is-overview-compact .value-unit-break {
    display: none;
}

.xeIndoorEnvInfo.is-overview-compact .indoor-env-info-title,
.xeIndoorEnvInfo.is-overview-compact .temp-title-font-style {
    font-size: 10px !important;
}

.xeIndoorEnvInfo.is-overview-compact .temp-value-font-style {
    font-size: 18px !important;
}

.xeIndoorEnvInfo.is-overview-compact .temp-unit-font-style {
    font-size: 11px !important;
}

.xeIndoorEnvInfo.is-overview-compact .index-label,
.xeIndoorEnvInfo.is-overview-compact .index-value {
    font-size: 9px;
}

.xeIndoorEnvInfo.is-overview-compact .env-card-div-content {
    gap: 2px;
}

.xeIndoorEnvInfo.is-overview-compact .icon-container {
    transform: translateY(0) scale(0.85);
    transform-origin: center;
}

.xeIndoorEnvInfo.is-overview-compact .temp-indices {
    margin-top: 2px;
    gap: 2px;
}

.xeIndoorEnvInfo.is-overview-compact .monitoring_wrap {
    height: calc(100% - 28px) !important;
    padding-top: 2px;
}
</style>
